import React from 'react';

function SidebarNew({ scrollCounter, sidebarLabel, onLogoClick }) {
  return (
    <aside className="fixed left-0 top-0 h-full sidebar z-50 flex flex-col items-center justify-between py-10 hidden lg:flex">
      <img 
        src="/logo.png" 
        alt="RamaInfra Logo" 
        className="w-16 h-16 object-contain cursor-pointer hover:opacity-80 transition-opacity" 
        onClick={onLogoClick}
      />
      
      <div className="flex flex-col items-center space-y-12">
        <div className="text-[40px] bank-gothic opacity-20">{scrollCounter}</div>
        <div 
          className="vertical-text bank-gothic text-[10px] tracking-[0.5em] text-neutral-500"
          dangerouslySetInnerHTML={{ __html: sidebarLabel }}
        />
      </div>
      
      <div className="flex flex-col space-y-6 text-neutral-600 text-xs">
        <span className="hover:text-amber-600">IG</span>
        <span className="hover:text-amber-600">TW</span>
      </div>
    </aside>
  );
}

export default SidebarNew;
